import { open_option } from '@actions/themes'
import type { ActionType } from '@interfaces/index'
import InvoiceNavButtons from '@fordeerTheme/components/buttons/invoice'
import { useContext } from '@utils/context'
import { useEffect } from 'react'
import { INVOICE_TOUR_TARGET_KEY } from '@features/virtual-tour/config/tourTargetCatalog'
import type { InvoiceVirtualTourStepDefinition } from '@features/virtual-tour/types/virtualTour.types'

const BRANDING_OPTION = InvoiceNavButtons.find((item) => item.id === 'btnBrand')

export const useTourStepEffects = (
  activeStep: number | null,
  stepDefinitions: InvoiceVirtualTourStepDefinition[],
) => {
  const [, dispatch] = useContext()

  useEffect(() => {
    if (activeStep === null || !BRANDING_OPTION) {
      return
    }

    const targetKey = stepDefinitions[activeStep]?.targetKey

    if (targetKey === INVOICE_TOUR_TARGET_KEY.themeEditorSectionNav) {
      const scrollBrandingNav = () => {
        document
          .querySelector('[data-tour="theme-editor-branding-nav"]')
          ?.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
      }

      scrollBrandingNav()
      const intervalId = window.setInterval(() => {
        const el = document.querySelector('[data-tour="theme-editor-branding-nav"]')
        if (el) {
          scrollBrandingNav()
          window.clearInterval(intervalId)
        }
      }, 200)

      return () => {
        window.clearInterval(intervalId)
      }
    }

    if (targetKey === INVOICE_TOUR_TARGET_KEY.themeEditorTypography) {
      dispatch(open_option(BRANDING_OPTION) as unknown as ActionType)

      window.requestAnimationFrame(() => {
        window.dispatchEvent(new Event('invoice-tour:open-branding-typography'))

        window.requestAnimationFrame(() => {
          document
            .querySelector('[data-tour="theme-editor-typography"]')
            ?.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        })
      })
    }


  }, [activeStep, dispatch, stepDefinitions])
}
